import { SurveyV2 } from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';

export const surveysRequests = {
  updateAssignedSurvey: EndpointDefinition.patch<
    SurveyV2.AssignedSurveyDto,
    SurveyV2.UpdateAssignedSurveyDto,
    { assignedSurveyId: number }
  >({
    name: 'updateAssignedSurvey',
    route: '/surveys/v2/assigned/:assignedSurveyId',
  }),

  updateAssignedSurveyNotes: EndpointDefinition.patch<
    SurveyV2.AssignedSurveyDto,
    SurveyV2.UpdateSurveyNotesDto,
    { assignedSurveyId: number }
  >({
    name: 'updateAssignedSurveyNotes',
    route: '/surveys/v2/assigned/:assignedSurveyId',
  }),

  setQuestionResponse: EndpointDefinition.post<
    SurveyV2.QuestionResponseViewDto,
    SurveyV2.AnswerQuestionDto,
    null
  >({
    name: 'updateQuestionResponse',
    route: '/surveys/v2/question-responses',
  }),

  submitAssignedSurvey: EndpointDefinition.post<
    SurveyV2.AssignedSurveyDto,
    null,
    { assignedSurveyId: number }
  >({
    name: 'submitAssignedSurvey',
    route: '/surveys/v2/assigned/:assignedSurveyId/submit',
  }),

  reopenAssignedSurvey: EndpointDefinition.post<
    SurveyV2.AssignedSurveyDto,
    null,
    { assignedSurveyId: number }
  >({
    name: 'reopenAssignedSurvey',
    route: '/surveys/v2/assigned/:assignedSurveyId/reopen',
  }),

  getAllSurveys: EndpointDefinition.get<SurveyV2.SurveyDto[], null>({
    name: 'getAllSurveys',
    route: '/surveys/v2',
  }),

  getSurveyById: new EndpointDefinition<
    SurveyV2.SurveyDto,
    null,
    { surveyId: number }
  >({
    name: 'getSurveyById',
    route: '/surveys/v2/:surveyId',
    method: 'GET',
  }),
};
